import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Fancybox from "../components/Fancybox";
import contact_info_bg from "../assets/img/contact_info_bg.jpg";
import a_feature_1_3 from "../assets/img/icon/a-feature_1_3.svg";
import bg_shape_4 from "../assets/img/shape/bg_shape_4.png";
import freshnessIcon from "../assets/img/freshnessIcon.png";
import delisiousIcon from "../assets/img/delisiousIcon.png";
import FranchisePageImage from "../assets/img/FranchisePageImage.jpg";
import zeppoliReelVideoOne from "../assets/img/reels/zeppoliReelVideoOne.mp4";
import zeppoliReelVideoFour from "../assets/img/reels/zeppoliReelVideoFour.mp4";
import { useFormik } from "formik";
import axios from "axios";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha";

function Franchise() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Franchise";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const [fullNameError, setFullNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [annualIncomeError, setAnnualIncomeError] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaValueError, setCaptchaValueError] = useState("");

  // Handle reCAPTCHA change
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    setCaptchaValueError("");
  };

  const formik = useFormik({
    initialValues: {
      howYouKnowZeppoliQuestion: "",
      fullName: "",
      email: "",
      mobileNumber: "",
      residentialAddress: "",
      city: "",
      cityInWhichStartFranchise: "",
      pinCode: "",
      state: "",
      academicQualification: "",
      workStatus: "",
      annualIncome: "",
      currentProfession: "",
      howInvolvedInFranchise: "",
      whoSitAtFranchise: "",
    },
    onSubmit: async (values, { resetForm }) => {
      let errorMessage = 0;
      const fullNameValidation = /^[a-zA-Z\s]+(?: [a-zA-Z\s]+)*$/;
      const mobileNumberValidation = /^\d{10}$/;
      const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const pinCodeValidation = /^\d{6}$/;
      const annualIncomeValidation = /^[0-9]+(?: [0-9]+)*$/;

      if (values.fullName === "") {
        setFullNameError("Full Name is Required");
        errorMessage++;
      } else if (!values.fullName.match(fullNameValidation)) {
        setFullNameError("Full Name Must Be Valid");
        errorMessage++;
      }

      if (values.email === "") {
        setEmailError("Email is Required");
        errorMessage++;
      } else if (!values.email.match(emailValidation)) {
        setEmailError("Email Must Be Valid");
        errorMessage++;
      }

      if (values.mobileNumber === "") {
        setMobileNumberError("Contact Number is Required");
        errorMessage++;
      } else if (!values.mobileNumber.match(mobileNumberValidation)) {
        setMobileNumberError("Contact Number Must Be Valid");
        errorMessage++;
      } else if (values.mobileNumber == "0000000000") {
        setMobileNumberError("Contact Number Must Be Valid");
        errorMessage++;
      }

      if (values.pinCode === "") {
        setPincodeError("Pincode is Required");
        errorMessage++;
      } else if (!values.pinCode.match(pinCodeValidation)) {
        setPincodeError("Pincode Must Be Valid");
        errorMessage++;
      }

      if (values.annualIncome === "") {
        setAnnualIncomeError("Annual Income is Required");
        errorMessage++;
      } else if (!values.annualIncome.match(annualIncomeValidation)) {
        setAnnualIncomeError("Annual Income Must Be Valid");
        errorMessage++;
      }

      const param = {
        howYouKnowZeppoliQuestion: values.howYouKnowZeppoliQuestion,
        fullName: values.fullName,
        email: values.email,
        mobileNumber: values.mobileNumber,
        residentialAddress: values.residentialAddress,
        city: values.city,
        cityInWhichStartFranchise: values.cityInWhichStartFranchise,
        pinCode: values.pinCode,
        state: values.state,
        academicQualification: values.academicQualification,
        workStatus: values.workStatus,
        annualIncome: values.annualIncome,
        currentProfession: values.currentProfession,
        howInvolvedInFranchise: values.howInvolvedInFranchise,
        whoSitAtFranchise: values.whoSitAtFranchise,
      };

      if (errorMessage == 0) {
        if (captchaValue !== "") {
          const response = await axios.post(
            "https://serverapi.xpertlab.com/zeppoli/franchiseform",
            param,
            {
              headers: {
                apitoken: "b361d6655jrsd4dd02efaf412ed585sd",
                "Content-Type": "application/json",
              },
            }
          );
          if (response.status === 200) {
            if (response.data.status === 200) {
              toast.success("Data Submitted Successfully");
              resetForm();
              setTimeout(() => {
                window.location.reload();
              }, 1500);
            } else {
              toast.error("Please Fill the Form");
            }
          } else {
            toast.error("Something Went Wrong");
          }
        } else {
          setCaptchaValueError("Please Check Captcha");
        }
      }
    },
  });
  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
  };

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // downside animation
  const variants6 = {
    hidden: { opacity: 0, y: -100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // right side animation

  // video play pause functionality
  const videoArray = [
    {
      videoLink: zeppoliReelVideoOne,
    },
    {
      videoLink: zeppoliReelVideoFour,
    },
  ];
  const videoRefs = useRef([]);
  const handlePlay = (index) => {
    // Pause all videos except the one that was just played
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });
  };

  return (
    <>
      <ToastContainer />
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={FranchisePageImage}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Franchise</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Franchise</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      {isVisible && (
        <div className="space">
          <div className="container">
            <div
              className="shape-mockup about-shape3"
              data-bottom="120px"
              data-left="15%"
            >
              <img src={bg_shape_4} alt="Zeppoli shape icon" />
            </div>
            <div className="row align-items-center">
              <div className="col-xl-6 mb-40 mb-xl-0">
                <div className="row justify-content-around">
                  {videoArray.map((data, index) => (
                    <div className="col-lg-6 my-1">
                      {index === 1 ? (
                        <motion.div
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true }}
                          variants={variants6}
                        >
                          <div className="video-box1">
                            <Fancybox options={opts}>
                              <video
                                key={index}
                                ref={(el) => (videoRefs.current[index] = el)}
                                onPlay={() => handlePlay(index)}
                                controls
                                style={{
                                  height: "400px",
                                  borderRadius: "12px",
                                }}
                              >
                                <source
                                  src={data.videoLink}
                                  type="video/mp4"
                                ></source>
                                <track
                                  src="captions_en.vtt"
                                  kind="captions"
                                  srclang="en"
                                  label="english_captions"
                                ></track>
                              </video>
                            </Fancybox>
                          </div>
                        </motion.div>
                      ) : (
                        <motion.div
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true }}
                          variants={variants5}
                        >
                          <div className="video-box1">
                            <Fancybox options={opts}>
                              <video
                                key={index}
                                ref={(el) => (videoRefs.current[index] = el)}
                                onPlay={() => handlePlay(index)}
                                controls
                                style={{
                                  height: "400px",
                                  borderRadius: "12px",
                                }}
                              >
                                <source
                                  src={data.videoLink}
                                  type="video/mp4"
                                ></source>
                                <track
                                  src="captions_en.vtt"
                                  kind="captions"
                                  srclang="en"
                                  label="english_captions"
                                ></track>
                              </video>
                            </Fancybox>
                          </div>
                        </motion.div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-xl-5 col-md-10 ps-xxl-5">
                <div data-aos="fade-up">
                  <div className="ms-xl-6">
                    <div className="title-area mb-30">
                      <span className="sub-title">The Zeppoli Bakers</span>
                      <h2 className="sec-title">
                        Join the Zeppoli Bakers Family
                      </h2>
                    </div>
                    <p className="mt-n2 mb-4">
                      Ready to turn your passion for baking into a thriving
                      business? Take the next step and become a Zeppoli Bakers
                      franchise owner. We're looking for individuals who share
                      our commitment to quality and customer satisfaction.
                    </p>
                    <div className="about-feature-wrap">
                      <div className="about-feature">
                        <div className="about-feature_icon">
                          <img
                            src={delisiousIcon}
                            alt="Zeppoli franchise form image"
                            style={{ width: "40px" }}
                          />
                        </div>
                        <div className="about-feature_text">DELICIOUS</div>
                      </div>
                      <div className="about-feature">
                        <div className="about-feature_icon">
                          <img
                            src={freshnessIcon}
                            alt="Zeppoli franchise form image"
                            style={{ width: "40px" }}
                          />
                        </div>
                        <div className="about-feature_text">FRESH</div>
                      </div>
                      <div className="about-feature">
                        <div className="about-feature_icon">
                          <img
                            src={a_feature_1_3}
                            alt="Zeppoli franchise form image"
                          />
                        </div>
                        <div className="about-feature_text">BEST PRICE</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isVisible && (
        <div
          className=""
          data-pos-for="#contactFormSec"
          style={{ marginBottom: "-150px" }}
        >
          <div className="container">
            <div className="row gy-4">
              <div className="col-lg-4">
                <div data-aos="fade-up">
                  <div className="contact-info" data-bg-src={contact_info_bg}>
                    <div className="contact-info_icon">
                      <i className="fal fa-phone"></i>
                    </div>
                    <h4 className="contact-info_title box-title">Phone</h4>
                    <span className="contact-info_text">
                      <a
                        href="tel:+919978232123"
                        name="Zeppoli contact number"
                        aria-label="Zeppoli contact number"
                      >
                        (+91) 99782 32123
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div data-aos="flip-left">
                  <div className="contact-info" data-bg-src={contact_info_bg}>
                    <div className="contact-info_icon">
                      <i className="fal fa-envelope"></i>
                    </div>
                    <h4 className="contact-info_title box-title">Email</h4>
                    <span className="contact-info_text">
                      <a
                        href="mailto:zeppolifoods123@gmail.com"
                        name="Zeppoli email"
                        aria-label="Zeppoli email"
                      >
                        zeppolifoods123@gmail.com
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div data-aos="fade-down">
                  <div className="contact-info" data-bg-src={contact_info_bg}>
                    <div className="contact-info_icon">
                      <i className="fal fa-location-dot"></i>
                    </div>
                    <h4 className="contact-info_title box-title">Location</h4>
                    <span className="contact-info_text">
                      <a
                        href="https://goo.gl/maps/fGye1Q3uUd1t65K28"
                        target="_blank"
                      >
                        Dhoraji, Dist. Rajkot Gujarat - 360410
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isVisible && (
        <section className="space bg-smoke2 mt-50" id="contactFormSec">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={variants5}
          >
            <div className="container space-top">
              <div className="contact-form ajax-contact mt-20">
                <h3 className="form-title">Express Your Franchise Interest</h3>
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="form-group col-12">
                      <select
                        placeholder="Hello"
                        {...formik.getFieldProps("howYouKnowZeppoliQuestion")}
                      >
                        <option value="" disabled selected hidden>
                          How did you Come to Know About Zeppoli Bakers?
                        </option>
                        <option value="Family/Friend">Family / Friend</option>
                        <option value="Franchise">Franchise</option>
                        <option value="Social Media">Social Media</option>
                        <option value="News Paper">News Paper</option>
                        <option value="Employee">Employee</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Your Full Name"
                        {...formik.getFieldProps("fullName")}
                        onChange={(e) => {
                          formik.setFieldValue("fullName", e.target.value);
                          setFullNameError("");
                        }}
                      />
                      <i className="fal fa-user"></i>
                      <span className="text-danger">{fullNameError}</span>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Your Email"
                        {...formik.getFieldProps("email")}
                        onChange={(e) => {
                          formik.setFieldValue("email", e.target.value);
                          setEmailError("");
                        }}
                      />
                      <i className="fal fa-envelope"></i>
                      <span className="text-danger">{emailError}</span>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Contact Number"
                        {...formik.getFieldProps("mobileNumber")}
                        onChange={(e) => {
                          formik.setFieldValue("mobileNumber", e.target.value);
                          setMobileNumberError("");
                        }}
                      />
                      <i className="fal fa-phone"></i>
                      <span className="text-danger">{mobileNumberError}</span>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Residential Address"
                        {...formik.getFieldProps("residentialAddress")}
                      />
                      <i className="far fa-location-dot"></i>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="City"
                        {...formik.getFieldProps("city")}
                      />
                      <i className="far fa-city"></i>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        className=""
                        placeholder="The City in Which you Want to Start Franchise"
                        {...formik.getFieldProps("cityInWhichStartFranchise")}
                      />
                      <i className="far fa-city"></i>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Pin Code"
                        {...formik.getFieldProps("pinCode")}
                        onChange={(e) => {
                          formik.setFieldValue("pinCode", e.target.value);
                          setPincodeError("");
                        }}
                      />
                      <i className="far fa-thumbtack"></i>
                      <span className="text-danger">{pincodeError}</span>
                    </div>
                    <div className="form-group col-md-6">
                      <select {...formik.getFieldProps("state")}>
                        <option value="" disabled selected>
                          Select State
                        </option>
                        <option value="Gujarat">Gujarat</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Rajsthan">Rajsthan</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <select
                        {...formik.getFieldProps("academicQualification")}
                      >
                        <option value="" disabled selected>
                          Select Academic Qualification
                        </option>
                        <option value="PHD">PHD</option>
                        <option value="Master Degree">Master Degree</option>
                        <option value="Post Graduation">Post Graduation</option>
                        <option value="Graduation">Graduation</option>
                        <option value="12th Pass">12th Pass</option>
                        <option value="10th Pass">10th Pass</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <select {...formik.getFieldProps("workStatus")}>
                        <option value="" disabled selected>
                          Select Work Status
                        </option>
                        <option value="Salaried">Salaried</option>
                        <option value="Self Employed">Self Employed</option>
                        <option value="Independent">Independent</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Annual Income"
                        {...formik.getFieldProps("annualIncome")}
                        onChange={(e) => {
                          formik.setFieldValue("annualIncome", e.target.value);
                          setAnnualIncomeError("");
                        }}
                      />
                      <i className="far fa-dollar-sign"></i>
                      <span className="text-danger">{annualIncomeError}</span>
                    </div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Current Profession"
                        {...formik.getFieldProps("currentProfession")}
                      />
                      <i className="far fa-briefcase"></i>
                    </div>
                    <div className="form-group col-md-6">
                      <select
                        {...formik.getFieldProps("howInvolvedInFranchise")}
                      >
                        <option value="" disabled selected>
                          How Involved will you be in Operating the Franchise?
                        </option>
                        <option value="Investor">Investor</option>
                        <option value="Partner">Partner</option>
                        <option value="Sole Proprietor">Sole Proprietor</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <select {...formik.getFieldProps("whoSitAtFranchise")}>
                        <option value="" disabled selected>
                          Who will Sit at the Franchise?
                        </option>
                        <option value="Owner">Owner</option>
                        <option value="Relative Person">Relative Person</option>
                        <option value="Manager">Manager</option>
                        <option value="Owner & Manager">Owner & Manager</option>
                      </select>
                    </div>
                    <div className="form-group col-12">
                      <div className="fw-bold text-primary mt-4 mx-2">
                        <ReCAPTCHA
                          sitekey="6Lfm3PcqAAAAACvfCZKWxwHJssSxiAODpGFvIE0A"
                          onChange={handleCaptchaChange}
                        />
                        <span className="text-danger">{captchaValueError}</span>
                      </div>
                    </div>
                    <div className="form-btn text-center col-12">
                      <button
                        type="submit"
                        className="th-btn"
                        name="formSubmit"
                        aria-label="formSubmit"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
                <p className="form-messages mb-0 mt-3"></p>
              </div>
            </div>
          </motion.div>
        </section>
      )}

      <Footer />
    </>
  );
}

export default Franchise;
